import { render, staticRenderFns } from "./Station.vue?vue&type=template&id=2afb3cbc&scoped=true&"
import script from "./Station.vue?vue&type=script&lang=js&"
export * from "./Station.vue?vue&type=script&lang=js&"
import style0 from "./Station.vue?vue&type=style&index=0&id=2afb3cbc&scoped=true&lang=scss&"
import style1 from "./Station.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afb3cbc",
  null
  
)

export default component.exports